import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ScheduleService } from 'src/app/api/departure/schedule.service';
import { GlobalService } from 'src/app/api/global.service';
import { SearchComponent } from 'src/app/components/search/search.component';
import * as moment from 'moment';
import { ScheduleDetailComponent } from '../schedule-detail/schedule-detail.component';
import { ScheduleOpenComponent } from '../schedule-open/schedule-open.component';
import { BookingsDetailExtendsComponent } from 'src/app/booking/bookings/bookings-detail-extends/bookings-detail-extends.component';
import { NavigationTrackerService } from 'src/app/utils/navigation-tracker.service';
import { ScheduleProjectionComponent } from '../schedule-projection/schedule-projection.component';
import { GeneralService } from 'src/app/api/config/general.service';
import { ToolsService } from 'src/app/utils/tools.service';
declare var $: any;

@Component({
  selector: 'app-schedule-list',
  templateUrl: './schedule-list.component.html',
  styleUrls: ['./schedule-list.component.css']
})
export class ScheduleListComponent implements OnInit {
  @ViewChild(ScheduleDetailComponent) ScheduleDetailComponent: any;
  @ViewChild(ScheduleOpenComponent) ScheduleOpenComponent: any;
  @ViewChild(BookingsDetailExtendsComponent)
  BookingsDetailExtendsComponent: any;
  @ViewChild(ScheduleProjectionComponent) ScheduleProjectionComponent: any;

  private thisComponent: ScheduleListComponent;

  branchofficeSlug = '';
  items: any = [];
  params: any = {
    search: ''
  };
  page = 1;
  count = 0;

  @ViewChild(SearchComponent) searchComponent: any;

  dataPagination: any = {
    pageSize: 0,
    currentPage: this.page,
    totalItems: 0
  };

  // variables ========
  tours_open: any = [];
  tours_finish: any = [];
  workinggroups: any = [];
  transfers: any = [];
  date_range: any = moment().format('YYYY-MM-DD');
  workinggroup_id: any = null;
  workinggroup_data: any = null;
  check_totals: any = 0;

  constructor(
    private routeActivated: ActivatedRoute,
    private scheduleService: ScheduleService,
    private globalService: GlobalService,
    private generalService: GeneralService,
    private toolsService: ToolsService,
    private router: Router,
    private navigationTrackerService: NavigationTrackerService
  ) {
    this.thisComponent = this;
    this.branchofficeSlug = this.globalService.slugBranchoffice;
  }

  ngOnInit() {
    this.list();
    this.getWorkingGroup();
    this.generateCalendar();
    (<any>$('[data-toggle="tooltip"]')).tooltip();
    this.navigationTrackerService.initializeMenu(this.routeActivated);
  }

  generateCalendar() {
    let component_ = this.thisComponent;
    (<any>$('#date_range')).daterangepicker(
      {
        locale: {
          format: 'YYYY-MM-DD'
        },
        singleDatePicker: true,
        startDate: moment(),
        showDropdowns: true,
        autoApply: true
      },
      function(chosen_date: any) {
        (<any>$('#date_range')).val(chosen_date.format('YYYY-MM-DD'));
        component_.date_range = chosen_date.format('YYYY-MM-DD');
        component_.check_totals = 0;
        component_.list();
      }
    );
  }

  list() {
    let val_params =
      'date_range=' +
      this.date_range +
      '&workinggroup_id=' +
      this.workinggroup_id;
    this.scheduleService.list(val_params).subscribe({
      next: (data: any) => {
        this.items = data.results;
        this.tours_open = data.tours_open;
        this.transfers = data.transfers;
        this.tours_finish = data.tours_finish.results;
        if (this.items.length > 0) {
          for (let i in this.items) {
            this.check_totals = this.check_totals + Number(this.items[i].total);
          }
        }
      }
    });
  }

  getWorkingGroup() {
    this.generalService.listWorkingGroup().subscribe({
      next: (data: any) => {
        this.workinggroups = data.results;
      }
    });
  }

  changeworkingGroup() {
    this.check_totals = 0;
    this.list();
    if (this.workinggroup_id != 'null') {
      this.workinggroup_data = this.toolsService.searchArrById(
        this.workinggroup_id,
        this.workinggroups
      );
    } else {
      this.workinggroup_data = null;
    }
  }

  viewdetail(item: any) {
    let data: any = {};
    data.date_range = this.date_range;
    data.workinggroup_id = this.workinggroup_id;
    data.workinggroup_data = this.workinggroup_data;
    data.tour = item;
    this.ScheduleDetailComponent.init(data);
  }

  viewToursOpen() {
    // let data:any  = {};
    // this.ScheduleOpenComponent.init(data);
    this.router.navigate([
      this.branchofficeSlug + '/salidas/cronograma/reservas/abiertas'
    ]);
  }

  refresh() {
    this.date_range = moment().format('YYYY-MM-DD');
    this.workinggroup_id = null;
    this.check_totals = 0;
    this.generateCalendar();
    this.list();
  }

  bookingDetail(booking: any) {
    booking.booking_id = booking.id;
    this.BookingsDetailExtendsComponent.init(booking);
  }

  scheduleProjection() {
    this.ScheduleProjectionComponent.init();
  }

  loadAfterTransfer(data: any) {
    this.list();
  }
}
